module.exports = __webpack_public_path__ + "img/woodStand-10.9157d05c.png";